import {
    LAUNCH_INIT,
    SET_CURRENT_APP_ID,
    SET_CURRENT_APPLICATION,
    LOAD_CURRENT_APPLICATION_REQUEST,
    SET_CURRENT_APPLICATION_LOADING,
    CHANGE_WEBHOOK_URL_REQUEST,
    CHANGE_ACCESS_RESTRICTED_REQUEST,
    CHANGE_ALLOW_SECURITY_URL_REQUEST,
    CHANGE_AUTHENTICATION_IN_CHAT_REQUEST,
    CHANGE_NOW_NOTIFICATION_REQUEST,
} from './constants'

const initialState = {
    toto: '',
    currentAppId: '',
    currentApp: {
        now_settings: {
            position: 'left',
            bottom_offset: 0,
            notification: false,
            hide_widget: false,
            one_to_one_channels: false,
            vip_channels: false,
        }
    },
    loadingCurrentApp: true
}

const reducer = (state = initialState, { type, payload, error }) => {
    switch (type) {
        case LAUNCH_INIT:
            return {
                ...state,
                toto: 'LAUNCHED'
            }
        case SET_CURRENT_APP_ID:
            return {
                ...state,
                currentAppId: payload
            }
        case LOAD_CURRENT_APPLICATION_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        case SET_CURRENT_APPLICATION:
            return {
                ...state,
                currentApp: {
                    ...payload.application,
                    now_settings: {
                        position: 'left',
                        bottom_offset: 0,
                        notification: false,
                        hide_widget: false,
                        one_to_one_channels: false,
                        ...(payload.application.now_settings ? payload.application.now_settings : {})
                    },
                },
                loadingCurrentApp: false
            }
        case SET_CURRENT_APPLICATION_LOADING:
            return {
                ...state,
                loadingCurrentApp: payload
            }
        case CHANGE_WEBHOOK_URL_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        case CHANGE_ACCESS_RESTRICTED_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        case CHANGE_ALLOW_SECURITY_URL_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        case CHANGE_AUTHENTICATION_IN_CHAT_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        case CHANGE_NOW_NOTIFICATION_REQUEST:
            return {
                ...state,
                loadingCurrentApp: true
            }
        default:
            return state
    }
}

export default reducer
